import script from "./info-card-title.vue?vue&type=script&setup=true&lang=ts"
export * from "./info-card-title.vue?vue&type=script&setup=true&lang=ts"

import "./info-card-title.vue?vue&type=style&index=0&id=1c4c024a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c4c024a"]])

export default __exports__